
RegExp.escape = function (s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
};

/* Estas funciones permiten agregar o remover a una url un 
   query string con una version para evitar el cacheo. */
function addCacheBreaker(url) {
    url = removeCacheBreaker(url);
    if (url.indexOf('?') === -1)
        return url + "?ver=" + new Date().getTime();
    else
        return url + "&ver=" + new Date().getTime();
}

var CACHE_BREAKER_REGEX = /(?:\?|&)ver=\d+$|(\?|&)ver=\d+&/;

function removeCacheBreaker(url) {
    return url.replace(CACHE_BREAKER_REGEX, '$1');
}
